export default {
  computed: {
    countPages() {
      return Math.ceil(this.total / this.count);
    },
  },
  data() {
    return {
      page: parseInt(this.$route.params.page),
    };
  },
  mounted() {
    this.query = this.getQuery;
    this.loadData();
  },
  methods: {
    search() {
      this.changePage(1);
      this.setQuery(this.query);
    },
    changePage(page) {
      this.$router.push({
        name: this.$route.name,
        params: { page },
      });
      this.loadData();
    },
    loadData() {
      this.getList({
        query: this.query,
        page: this.page,
        count: this.count,
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.page = to.params.page;
    next();
  },
};
